/**
 * @description: 库存数量明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="sr-ksm-report">
        <div class="ksm-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="time">
                        <input type="text" class="form-control laydate-icon" v-model="startTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="endTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="printer_stock_input" data-placeholder="请选择仓库" disabled>
                    </select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="selecttypes"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">单据类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="invoice_type">
                        <option value="">全部</option>
                        <option value="1">订单销售</option>
                        <option value="2_1">采购进货</option>
                        <option value="2_2">采购进货-赠送</option>
                        <option value="2_3">采购进货-盈余</option>
                        <option value="2_4">采购进货-换货</option>
                        <option value="3">采购退货</option>
                        <option value="4">库存盘点</option>
                        <option value="5">寄存单</option>
                        <option value="6">退货单</option>
                        <option value="7">报损单</option>
                        <option value="8">领用单</option>
                        <option value="9">库存调拨</option>
                        <option value="10_1">充公单</option>
                        <option value="10_3">取消充公单</option>
                        <option value="13">取酒单</option>
                        <option value="14">作废核减</option>
                        <option value="2_5">采购进货-客遗</option>
                        <option value="15">配料消耗</option>
                    </select>
                </div>
                <label class="list-label-4">库存变化:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stock_change">
                        <option value="">全部</option>
                        <option value="1">入库</option>
                        <option value="2">出库</option>
                    </select>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="goods_name">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getKmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">入库数量:</label>
                <div class="list-total" ref="in_total"></div>
                <label class="list-label-4">出库数量:</label>
                <div class="list-total" ref="out_total"></div>
                <label class="list-label-4">库存结存:</label>
                <div class="list-total" ref="remain_total"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="orderlist"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div ref="kmExport_alert" class="ele-hide">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='kmExport_allcheck' @click='kmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="time">
                            <label>操作时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="relation_id">
                            <label>单据编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="type">
                            <label>单据类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="status">
                            <label>库存变化</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="quantity">
                            <label>数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="buying_price_total">
                            <label>进货价合计</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='kmExport_checkModel' value="remark">
                            <label>备注</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='kmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='kmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                startTime: "",
                endTime: "",
                shopDatas: [],
                goods_name: "",
                kmExport_allcheck: false,
                c_kmExport_allcheck: false,
                kmExport_checkModel: [],
                kmExport_checkData: ['time', 'relation_id', 'type', 'status', 'store_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'buying_price', 'buying_price_total', 'remark'],
                kmExport_type: 1,
            }
        },
        watch: {
            kmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.kmExport_checkModel.length >= this.kmExport_checkData.length) {
                        this.kmExport_allcheck = true;
                        this.c_kmExport_allcheck = true;
                    } else {
                        this.kmExport_allcheck = false;
                        this.c_kmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.getGoodsType(); // 商品类型
            this.innitInput(); // 门店
            $(this.$refs.invoice_type).val('').trigger('change');
            $(this.$refs.invoice_type).select2({
                minimumResultsForSearch: -1,
                width: '100%'
            });
            $(this.$refs.stock_change).val('').trigger('change');
            $(this.$refs.stock_change).select2({
                minimumResultsForSearch: -1,
                width: '100%'
            });
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    }
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.printer_stock_input).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.printer_stock_input).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.printer_stock_input).prop("disabled", false);
                            $(_this.$refs.printer_stock_input).val('').trigger('change');
                            _this.getstockdata(data.response.result[1].id);
                            _this.innitTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.printer_stock_input).html("");
                $(this.$refs.printer_stock_input).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.selecttypes).html("");
                            $(_this.$refs.selecttypes).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 库存数量明细报表
            innitTable: function() {
                let _this = this;
                $(_this.$refs.orderlist).bootstrapTable('destroy');
                $(_this.$refs.orderlist).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getOrderList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "time",
                        title: "操作时间",
                        width: "100"
                    }, {
                        field: "relation_id",
                        title: "单据编号",
                        width: "110"
                    }, {
                        field: "type",
                        title: "单据类型",
                        width: "7%"
                    }, {
                        field: "status",
                        title: "库存变化",
                        width: "7%"
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "7%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "7%"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "6%"
                    }, {
                        field: "quantity",
                        title: "数量",
                        width: "6%"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "7%"
                    }, {
                        field: "buying_price_total",
                        title: "进货价合计",
                        width: "7%"
                    }, {
                        field: "remark",
                        title: "备注",
                        width: "7%"
                    }],
                });
            },
            // 获取库存数量明细报表列表
            getOrderList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    store_id = $.trim($(_this.$refs.printer_stock_input).val()),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.startTime,
                            "end_date": _this.endTime,
                            "shop_id": shop_id,
                            "store_id": store_id,
                            "goods_type": $.trim($(_this.$refs.selecttypes).val()),
                            "type": $(_this.$refs.invoice_type).val(),
                            "status": $(_this.$refs.stock_change).val(),
                            "goods_name": _this.goods_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGoodsStockDetailList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                            $(_this.$refs.in_total).text(data.response.result.total_in_quantity);
                            $(_this.$refs.out_total).text(data.response.result.total_out_quantity);
                            $(_this.$refs.remain_total).text(data.response.result.balance_quantity);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getKmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/detailCommonExport?bill_type=stock"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.kmExport_checkModel = data.response.result.export_fields;
                                _this.kmExport_type = data.response.result.export_type;
                            } else {
                                _this.kmExport_checkModel = _this.kmExport_checkData;
                                _this.kmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.kmExport_alert)
                }, function() {
                    _this.exportKmList();
                });
            },
            // 导出字段全选
            kmExportCheckedAll: function() {
                let _this = this;
                _this.kmExport_allcheck = _this.c_kmExport_allcheck;
                if(!_this.kmExport_allcheck) { // 实现全选
                    _this.kmExport_checkModel = [];
                    _this.kmExport_checkData.forEach(function(item) {
                        _this.kmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.kmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportKmList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.kmExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/detailCommonExport?bill_type=stock" +
                    "&start_date=" + _this.startTime +
                    "&end_date=" + _this.endTime +
                    "&shop_id=" + $(_this.$refs.shop).val() +
                    "&store_id=" + $.trim($(_this.$refs.printer_stock_input).val()) +
                    "&goods_type=" + $.trim($(_this.$refs.selecttypes).val()) +
                    "&type=" + $(_this.$refs.invoice_type).val() +
                    "&status=" + $(_this.$refs.stock_change).val() +
                    "&goods_name=" + _this.goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.kmExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .ksm-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                // width: 1300px;
                // table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>